module.exports = __webpack_public_path__ + "static/img/wavm8s-014-valiska.a7db298.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wav/wavm8s-014-valiska.png
// module id = 5LGa
// module chunks = 0